const utils = {
  borderRadius: '.28571429rem',
  inputLineHeight: '1.21428571em',
  inputPadding: '.57857143em 1em'
};

export default utils;
